import React, { ComponentProps, memo } from 'react'

import { Box, NumberInput } from '@surglogs-app/ui'

import { useTranslation } from '../services'

export const RemindersEditorListItemAmountInput = memo(
  ({ disabled, ...rest }: ComponentProps<typeof NumberInput>) => {
    const { t } = useTranslation()

    return (
      <Box {...{ flex: 1 }}>
        <NumberInput
          {...{
            onlyPositive: true,
            integer: true,
            disabled,
            precision: 9,
            min: 1,
            placeholder: t('amountInputPlaceholder'),
            'aria-label': 'reminder-amount-input',
            role: 'spinbutton',
            ...rest,
          }}
        />
      </Box>
    )
  },
)
